import { Injectable } from '@angular/core';

@Injectable()
export class Formvalidator {

    formValidation: any;
    numberSpaceChar = new RegExp("^[A-Öa-ö0-9 &-]*[A-Öa-ö0-9][A-Öa-ö0-9 &-]*$");

    private errorMsgUpdateOrganisation: string = 'Fältet är notSpecified hos organisationen. Uppdatera informationen hos organisationen i organisations-vyn.'

    constructor() {
        this.setDefault();
    }

    /*
    * Initiator to set default values
    */
    setDefault(){
        this.formValidation = {
            companyNameError: false,

            companyOrgNrError: false,
            companyStreetAddressError: false,
            companyPostalCodeError: false,
            companyCityError: false,
            companySecurityContactPersonError: false,
            securityAgreementStatusError: false,

            companySecurityOfficerError: false,
            clientSecurityOfficerError: false,
            clientStreetAddressError: false,
            clientContactPersonError: false
        }
    }

    /*
    * Validates a given FAS form to ensure that we only try to save data that is allowed
    */
    validateFasForm(fasForm, modalData = ["", ""]) { 
        modalData[0] = "Valideringsfel";
        modalData[1] = "Vi kunde inte hitta vad som gick fel."; 
        if(!this.validateClientSecurityOfficer(fasForm.clientSecurityOfficer, modalData)
                && !this.validateClientStreetAddress(fasForm.clientStreetAddress, modalData)
                && !this.validateClientContactPerson(fasForm.clientContactPerson, modalData)
                && !this.validateCompanyName(fasForm.companyName, modalData)
                && !this.validateCompanySecurityOfficer(fasForm.companySecurityOfficer, modalData)
                && !this.validateCompanyOrgNr(fasForm.organisationId, modalData)
                && !this.validateCompanyStreetAddress(fasForm.companyStreetAddress, modalData)
                && !this.validateCompanyPostalCode(fasForm.companyPostalCode, modalData)
                && !this.validateCompanyCity(fasForm.companyCity, modalData)
                && !this.validateCompanyContactPerson(fasForm.companyContactPerson, modalData)
                && !this.validateSecurityAgreementStatus(fasForm.securityAgreementStatus, modalData)
            ) {
                return true;
            }
            return false;
    }

    /*
    * Method to help the user not attempting to store invalid parameters
    * Validates check if: Field is empty, field is containing allowed characters
    */
    validateClientSecurityOfficer(input, modalData = ["", ""]) {
        if(!input) {
            modalData[0] = "Fel i fält - Beställare: Handläggare";
            modalData[1] = `Fältet får inte vara tomt. ${this.errorMsgUpdateOrganisation}`;
            return this.formValidation.clientSecurityOfficerError = true;
        }
        if(input != null && this.numberSpaceChar.test(input)) {
            return this.formValidation.clientSecurityOfficerError = false;
        } else {
            modalData[0] = "Fel i fält - Beställare: Handläggare";
            modalData[1] = `Fältet får endast innehålla siffror eller bokstäver. ${this.errorMsgUpdateOrganisation}`;
            return this.formValidation.clientSecurityOfficerError = true;
        }
    }

    /**
     * Validates the client's contact person.
     * @param input Input contact person
     * @param modalData Modal data.
     */
    validateClientContactPerson(input, modalData = ["", ""]) {
        if (!input) {
            modalData[0] = "Fel i fält - Beställare: Kontaktperson";
            modalData[1] = `Fältet får inte vara tomt. ${this.errorMsgUpdateOrganisation}`;
            return this.formValidation.clientContactPersonError = true;
        }
        if(this.numberSpaceChar.test(input)) {
            return this.formValidation.clientContactPersonError = false;
        } else {
            modalData[0] = "Fel i fält - Beställare: Kontaktperson";
            modalData[1] = `Fältet får endast innehålla siffror eller bokstäver. ${this.errorMsgUpdateOrganisation}`;
            return this.formValidation.clientContactPersonError = true;
        }
    }

    /**
     * Validates the client's street address.
     * @param input Form input data.
     * @param modalData Modal data.
     */
    validateClientStreetAddress(input, modalData = ["", ""]) {
        if (!input) {
            modalData[0] = "Fel i fält - Beställare: Adress";
            modalData[1] = `Fältet får inte vara tomt. ${this.errorMsgUpdateOrganisation}`;
            return this.formValidation.clientStreetAddressError = true;
        }
        if(this.numberSpaceChar.test(input)) {
            return this.formValidation.clientStreetAddressError = false;
        } else {
            modalData[0] = "Fel i fält - Beställare: Adress";
            modalData[1] = `Fältet får endast innehålla siffror eller bokstäver. ${this.errorMsgUpdateOrganisation}`;
            return this.formValidation.clientStreetAddressError = true;
        }
    }

    /*
    * Method to help the user not attempting to store invalid parameters
    * Validates check if: Field is empty, field is containing allowed characters
    */
    validateCompanySecurityOfficer(input, modalData = ["", ""]) {
        if(!input) {
            modalData[0] = "Fel i fält - Företag: Handläggare";
            modalData[1] = "Fältet får inte vara tomt.";
            return this.formValidation.companySecurityOfficerError = true;
        }
        if(input != null && this.numberSpaceChar.test(input)) {
            return this.formValidation.companySecurityOfficerError = false;
        } else {
            modalData[0] = "Fel i fält - Företag: Handläggare";
            modalData[1] = "Fältet får endast innehålla siffror eller bokstäver.";
            return this.formValidation.companySecurityOfficerError = true;
        }
    }

    /*
    * Method to help the user not attempting to store invalid parameters
    * Validates check if: Field is empty, field is containing allowed characters
    */
    validateCompanyStreetAddress(input, modalData = ["", ""]) {
        if(!input) {
            modalData[0] = "Fel i fält - Företag: Adress";
            modalData[1] = "Fältet får inte vara tomt.";
            return this.formValidation.companyStreetAddressError = true;
        }
        if(input != null && this.numberSpaceChar.test(input)) {
            return this.formValidation.companyStreetAddressError = false;
        } else {
            modalData[0] = "Fel i fält - Företag: Adress";
            modalData[1] = "Fältet får endast innehålla siffror eller bokstäver.";
            return this.formValidation.companyStreetAddressError = true;
        }
    }

    /*
    * Method to help the user not attempting to store invalid parameters
    * Validates check if: Field is empty, field is containing allowed characters
    */
    validateCompanyContactPerson(input, modalData = ["", ""]) {
        if(!input) {
            modalData[0] = "Fel i fält - Företag: Kontaktperson";
            modalData[1] = "Fältet får inte vara tomt.";
            return this.formValidation.companySecurityContactPersonError = true;
        }
        if(input != null && this.numberSpaceChar.test(input)) {
            return this.formValidation.companyStreetAddressError = false;
        } else {
            modalData[0] = "Fel i fält - Företag: Kontaktperson";
            modalData[1] = "Fältet får endast innehålla siffror eller bokstäver.";
            return this.formValidation.companySecurityContactPersonError = true;
        }
    }

    /*
    * Method to help the user not attempting to store invalid parameters
    * Validates check if: Field is empty, field is containing allowed characters
    */
    validateCompanyName(input, modalData = ["", ""]) {
        if(!input) {
            modalData[0] = "Fel i fält - Företag: Namn";
            modalData[1] = "Fältet får inte vara tomt.";
            return this.formValidation.companyNameError = true;
        }
        if(input != null && this.numberSpaceChar.test(input)) {
            return this.formValidation.companyNameError = false;
        } else {
            modalData[0] = "Fel i fält - Företag: Namn";
            modalData[1] = "Fältet får endast innehålla siffror eller bokstäver.";
            return this.formValidation.companyNameError = true;
        }
    }

    /*
    * Method to help the user not attempting to store invalid parameters
    * Validates check if: Field is empty, field is containing allowed characters
    */
    validateCompanyCity(input, modalData = ["", ""]) {
        if(!input) {
            modalData[0] = "Fel i fält - Företag: Stad";
            modalData[1] = "Fältet får inte vara tomt.";
            return this.formValidation.companyCityError = true;
        }
        if(input != null && this.numberSpaceChar.test(input)) {
            return this.formValidation.companyCityError = false;
        } else {
            modalData[0] = "Fel i fält - Företag: Stad";
            modalData[1] = "Fältet får endast innehålla siffror eller bokstäver.";
            return this.formValidation.companyCityError = true;
        }
    }

    /*
    * Method to help the user not attempting to store invalid parameters
    * Validates check if: Field is empty, field is containing allowed characters
    */
    validateCompanyPostalCode(postCode, modalData = ["", ""]) {
        if (postCode === null || postCode.trim().length < 2) {
            modalData[0] = "Fel i fält - Företag: Postnummer";
            modalData[1] = "Postnummer måste vara minst två karaktärer för att godkännas.";
            return this.formValidation.companyPostalCodeError = true;
        } 

        postCode = postCode.replace(" ", "")  // strip out all white spaces

        if (isNaN(postCode.trim())) {
            modalData[0] = "Fel i fält - Företag: Postnummer";
            modalData[1] = "Postnummer får enbart innehålla siffror för att godkännas.";
            return this.formValidation.companyPostalCodeError = true;  
        }
        return this.formValidation.companyPostalCodeError = false;                
    }

    /**
     * Validate Security contract option 
     * @param input Option selected
     * @param modalData Error modal
     */
    validateSecurityAgreementStatus(input, modalData = ["", ""]) {
        if(input != "fas_notSent" && input != "fas_sent" && input != "fas_closed" && input != "fas_approved") {
            modalData[0] = "Fel i fält - FAS-Status";
            modalData[1] = "Ett alternativ måste väljas.";
            return this.formValidation.securityAgreementStatusError = true;
        } else {
            return this.formValidation.securityAgreementStatusError = false;
        }
    }

    /*
    * Method to help the user not attempting to store invalid parameters
    * Validates check if: Field is empty, field is containing allowed characters
    */
    validateCompanyOrgNr(id, modalData = ["", ""]) {
        if(!id) {
            modalData[0] = "Fel i fält - Företag: Organisationsnummer";
            modalData[1] = "Fältet är tomt.";
            return this.formValidation.companyOrgNrError = true;
        }

        if(id.charAt(0) === '2' || id.charAt(0) === '3' || id.charAt(0) === '5' || id.charAt(0) === '6') {
            if(!(id.trim().replace(/\D/g, "").length === 10)) {
                modalData[0] = "Fel i fält - Företag: Organisationsnummer";
                modalData[1] = "Organisationsnumret måste börja på en godkänd siffra (2, 3, 5 eller 6).";
                return this.formValidation.companyOrgNrError = true;
            }
        }

        id = id.match(/[0-9]{6}-[0-9]{4}/g);
            if(id === null){
                modalData[0] = "Fel i fält - Företag: Organisationsnummer";
                modalData[1] = "Organisationsnumret är felaktigt formaterat.";
                return this.formValidation.companyOrgNrError = true;
            } else {
                id = id[0];
            }

            id = id
            .replace(/\D/g, "")     // strip out all but digits
            .split("")              // convert string to array
            .reverse()              // reverse order for Luhn

            // verify we got 10 digits, otherwise it is invalid
            if (id.length != 10) {
                modalData[0] = "Fel i fält - Företag: Organisationsnummer";
                modalData[1] = "Organisationsnumret är felaktigt formaterat.";
                return this.formValidation.companyOrgNrError = true;
            }

            var sum = id
                // convert to number
                .map(function(n) {
                    return Number(n);
                })
                // perform arithmetic and return sum
                .reduce(function(previous, current, index) {
                    // multiply every other number with two
                    if (index % 2) current *= 2;
                    // if larger than 10 get sum of individual digits (also n-9)
                    if (current > 9) current -= 9;
                    // sum it up
                    return previous + current;
                });

            // sum must be divisible by 10   
            if (0 === sum % 10) {
                this.formValidation.companyOrgNrError = false;   
            } else {
                this.formValidation.companyOrgNrError = true;
                modalData[0] = "Fel i fält - Företag: Organisationsnummer";
                modalData[1] = "Organisationsnumret är korrekt formaterat, men inte giltigt. Kontrollera att du skrivit rätt.";
                return this.formValidation.companyOrgNrError = true;
            }
            
            return this.formValidation.companyOrgNrError = false;
    }

}